export enum GrindInspectionAddStatus {
  ACCEPTED = "accepted",
  REJECTED = "rejected",
  SEND_FOR_APPROVAL = "waiting_for_approval",
  REWORKED = "reworked",
  CARRY_OVER = "carry_over",
  STORED = "stored",
  SHIPPED = "shipped",
}
